import { render, staticRenderFns } from "./IdentityInfoEdit.vue?vue&type=template&id=fe4ccac6&scoped=true&"
import script from "./IdentityInfoEdit.vue?vue&type=script&lang=js&"
export * from "./IdentityInfoEdit.vue?vue&type=script&lang=js&"
import style0 from "./IdentityInfoEdit.vue?vue&type=style&index=0&id=fe4ccac6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4ccac6",
  null
  
)

export default component.exports